import { z } from 'zod';

import { collectionPath, defineModelSpec, orderBy } from '@elara/firebolt/shared';

import { PaymentMethodMetadataShape } from './schemas/payment-method-schemas.js';
import { id, userId } from './schemas/zod-types.js';

/**
 * The canonical `ModelSpec` for a user's saved payment methods (wallet), stored as a per-user
 * subcollection at `users/{userId}/paymentMethods/{id}`.
 *
 * This document holds ONLY safe display metadata (brand, last4, expiry, cardholder, nickname, default) —
 * it is client-readable (owner-only) so the wallet UI can render reactively. The reusable PCI Booking
 * vault token lives in a SEPARATE server-only sibling ({@link PaymentMethodTokenModelSpec}) so it can
 * never reach the browser. `createdAt`/`updatedAt` are added automatically.
 */
export const PaymentMethodModelSpec = defineModelSpec({
  path: collectionPath`users/${userId}/paymentMethods/${id}`,
  shape: {
    ...PaymentMethodMetadataShape,
    isDefault: z.boolean().default(false).describe('Whether this is the user’s default card'),
  },
  constraints: [orderBy('createdAt', 'desc')],
});
export type PaymentMethodModelSpec = typeof PaymentMethodModelSpec;
